export default __webpack_public_path__ + "static/media/Clipboard.c8feaaf6.svg";